import Pusher from 'pusher-js/with-encryption';
import config from 'shared/config/config.js';


var APP_KEY
switch (config.env) {
  case 'production':
    APP_KEY = 'fbba2ac7bf4c4ba05d14';
    break;

  case 'staging':
    APP_KEY = 'eb7460be7b9036bf9eb8';
    break;

  default:
    APP_KEY = 'b46cb25591e56c3118e2';
}

const pusher = new Pusher(APP_KEY);

export const onAccountMessage = (accountId, source, action, callback) => {
  onMessage(`account-${accountId}`, source, action, callback);
}

export const onUserMessage = (userId, source, action, callback) => {
  onMessage(`user-${userId}`, source, action, callback);
}

export const onMessage = (channel, source, action, callback) => {
  (pusher.channel(channel) || pusher.subscribe(channel))
    .bind('pull', msg => {
      if (msg.source === source && msg.action === action) {
        callback(msg);
      }
    });
}

export const unSubChannel = (channel) => {
  pusher.unsubscribe(channel);
}
